IREP.leaderboardBand = (function () {
    var animate = function () {
        var wrapper = $("#leaderboardBandWrapper");
        var sidebar = wrapper.find(".sidebar");
        var content = wrapper.find(".content");
        var band = wrapper.find("#leaderboardBand");
        var leadersDiv = band.find("#leaders");
        var leaders = leadersDiv.find(".leader");

        var height = (leaders.first().outerHeight(true) + leaders.first().outerHeight(false)) / 2;
        var duration = 0.35;
        var slideLeftAnimation = { css: { marginLeft: "0", opacity: 1 } };

        var bandTimeline = new TimelineMax();

        // animate the left side
        bandTimeline.to(sidebar, 1, slideLeftAnimation);
        
        // animate the leaderboard title
        bandTimeline.to(band.find(".title"), 0.25, { opacity: 1 });
        
        // animate the shield
        bandTimeline.to(band.find("#shield"), 0.25, { opacity: 1, scale: 1.2 });

        // animate the leader items (flip each one and scroll between groups of 3)
        if (leaders.length > 0) {
            var firstRun = true;
            for (var i = 0; i < leaders.length; i++) {
                bandTimeline.to($(leaders[i]), duration, { opacity: 1, rotationX: 1 });

                var nextIndex = i + 1;

                if (nextIndex < leaders.length && nextIndex % 3 === 0) {
                    
                    // animate the footer link after the first group of leader animations
                    if (firstRun) {
                        bandTimeline.to(wrapper.find(".footer-access #link"), 0.25, { css: { marginRight: "0", opacity: 1 } });
                        firstRun = false;
                    }

                    bandTimeline.to([], 2);
                    bandTimeline.to(leadersDiv, duration, { scrollTop: height * nextIndex });
                    
                }
            }
        }
    };
    
    return {
        animate: animate
    };
})();